import { render, staticRenderFns } from "./EventsEvents.vue?vue&type=template&id=29017c29"
import script from "./EventsEvents.vue?vue&type=script&lang=js"
export * from "./EventsEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports